import React from 'react';
import { TableItemActionsNew, Icons } from 'components';

const columns = (showDialog, navigate, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه درخواست',
    field: 'source?.entityId',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.source?.entityId ? rd?.source?.entityId : '-'),
  },
  {
    title: 'مدت اعتبار ضمانت‌نامه (روز)',
    field: 'warrantyDuration',
    sorting: false,
    align: 'center',
    render: (rc) => (rc?.source?.warrantyDuration ? rc?.source?.warrantyDuration : '-'),
  },

  {
    title: 'مهلت تکمیل اطلاعات ',
    field: 'source?.duePersianDate',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rc) => (rc?.source?.inquiryRegister?.contractDate ? rc?.source?.inquiryRegister?.contractDate : '-'),

  },
  {
    title: 'نام ذینفع ',
    field: 'source?.stakeholderName',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rc) => (rc?.source?.stakeholderName ? rc?.source?.stakeholderName : '-'),
  },
  {
    title: 'نوع ضمانت‌نامه',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'source?.warrantyType',
    render: (rd) => (rd?.source?.warrantyType === 'PARTICIPATION_TENDERS' || rd?.source?.warrantyType === 'CASH_PARTICIPATION_TENDERS' ? `شرکت در مناقصه` : rd?.source?.warrantyType),
  },
  {
    title: 'مرحله',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'source?.warrantyStep',
    render: (rd) => step[rd?.source?.warrantyStep],
  },
  {
    title: 'وضعیت',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'source?.warrantyStatus',
    render: (rd) => status[rd?.source?.warrantyStatus],
  },

  ...((actionsList['listWarrantyDetailPage'] || actionsList['cancelListWarrantyPage']) ? [{
    title: 'عملیات',
    field: 'operation',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        style={{ justifyContent: 'center' }}
        title=""
        align='center'
        otherMenus={
          [
            {
              title: 'جزئیات ',
              isShow: !!actionsList['listWarrantyDetailPage'],
              onClick: () => navigate('/Warranty/RequestDetail/' + row?.source?.entityId)
            },
            {
              title: 'لغو درخواست',
              isShow: !!actionsList['cancelListWarrantyPage'],
              onClick: () => showDialog(row),
              disabled: chackDisable(row)
              // در صورتی که در مرحله استعلام مدارک و بررسی وثیقه و همچنین در وضعیت های تکمیل نشده و در انتظار بود دکمه لغو درخواست فعال است
            },


          ]}
      />
    ),
  },
  ] : [])
];

const status = {
  EXPIRED: 'منقضی شده',
  REJECTED: 'رد شده',
  WAITING: 'در انتظار',
  ERROR: 'خطا ',
  CREATED: 'ایجاد شده',
  INCOMPLETE: 'تکمیل نشده',
  CANCELED: 'لغو شده'
};
const step = {
  EDIT_INFO: 'استعلام مدارک',
  INFO: 'استعلام مدارک',
  REGISTER_INQUIRY: 'استعلام مدارک',
  REGISTER_COLLATERAL: 'بررسی وثیقه',
  COLLATERAL_INQUIRY: 'بررسی وثیقه',
  REGISTER_CONTRACT: 'ایجاد قرارداد',
  REGISTERED: 'صدور ضمانت‌نامه',
  SIGNATURE_CONTRACT: 'امضا قرارداد',
  FILING: 'تشکیل پرونده',
  PENDING_TO_REGISTER: 'صدور ضمانت‌نامه',
  UNREGISTERED: 'صدور ضمانت‌نامه',

};
const chackDisable = (row) => {
  if ((row?.source?.warrantyStep == 'REGISTER_INQUIRY' ||
    row?.source?.warrantyStep == 'REGISTER_COLLATERAL' ||
    row?.source?.warrantyStep == 'INFO' ||
    row?.source?.warrantyStep == 'EDIT_INFO' ||
    row?.source?.warrantyStep == 'COLLATERAL_INQUIRY') &&
    (row?.source?.warrantyStatus == 'WAITING' ||
      row?.source?.warrantyStatus == 'INCOMPLETE')) {
    return false;
  } else {
    return true;

  }
}
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
